// use a script tag or an external JS file
document.addEventListener("DOMContentLoaded", (event) => {
gsap.registerPlugin(ScrollTrigger)

const animContainer = document.getElementById("footer-lottie-container");
const lottieLink = animContainer.dataset.lottieLink;

const anim = lottie.loadAnimation({
    container: animContainer,
    renderer: "svg",
    loop: false,
    autoplay: false,
    path: lottieLink
});

anim.addEventListener("DOMLoaded", function () {
    const totalFrames = anim.totalFrames;
    const obj = { frame: 0 };
    

    gsap.to(obj, {
        frame: totalFrames - 0.5,
        ease: "none",
        scrollTrigger: {
        trigger: ".footer-lottie-animation__container",
        start: "100% bottom",
        end: "top top",
        scrub: 2,
        },
        onUpdate: () => {
        anim.goToAndStop(obj.frame, true);
        }
    });
    });
});